import { defineRule } from 'vee-validate';
import { email, min } from '@vee-validate/rules';

defineRule('required', (value: any) => {
  if (
    value === null ||
    value === undefined ||
    (Array.isArray(value) && value.length === 0) ||
    !String(value).trim().length
  ) {
    return 'fields.error_message';
  }

  return true;
});

defineRule('requiredDateRange', (value: any) => {
  const validDate = /^\d{4}-\d{2}-\d{2}$/;

  if (Array.isArray(value)) {
    if (!validDate.test(value?.[0] ?? '')) {
      return 'fields.error_message';
    }
    if (!validDate.test(value?.[1] ?? '')) {
      return 'fields.error_message';
    }
  }

  if (
    value === null ||
    value === undefined ||
    !String(value).trim().length ||
    (!validDate.test(value) && !Array.isArray(value))
  ) {
    return 'fields.error_message';
  }

  return true;
});

defineRule('email', (value: any) => {
  if (!value || !value.length || !email(value)) {
    return 'fields.invalid_email';
  }
  return true;
});
defineRule('min', min);

defineRule('objectHasName', (value: any) => {
  if (value?.name === undefined || value.name === null || value.name === '') {
    return 'fields.error_message';
  }
  return true;
});

defineRule('terms', (value: boolean) => {
  if (!value) {
    return 'fields.terms_required';
  }

  return true;
});
